import * as React from "react";
import Card from "../core/Card";
import Button from "../core/Button";
import {useState, useEffect} from "react";
import {jfetch, toast} from "../../utils";

interface Iprops{
  orgID: number;
}

function OrgPermissions(props:Iprops){
  const [tools, setTools] = useState([])
  const [courses, setCourses] = useState([])
  const [folders, setFolders] = useState([])
  const [loading, setLoading] = useState(false)

  const [ts, setTs] = useState([])
  const [cs, setCs] = useState([])
  const [fs, setFs] = useState([])

  const [search, setSearch] = useState('')

  useEffect(() => {
    jfetch.get(`/organizations/${props.orgID}/keys`)
    .then((resp) => {
      setTools(resp.tools)
      setTs(resp.tools)
      setCourses(resp.courses)
      setCs(resp.courses)
      setFolders(resp.folders)
      setFs(resp.folders)
    })
  }, [])

  useEffect(run_search, [search])

  function update_keys(){
    setLoading(true)
    let tool_keys = []
    let course_keys = []
    let folder_keys = []
    tools.forEach(tool => {
      if(tool.access == true){
        let t = {global:false, access:true, keyable_id:tool.id, keyable_type:"Tool"}
        tool_keys.push(t)
      }
    });
    courses.forEach(course => {
      if(course.access == true){
        let c = {global:false, access:true, keyable_id:course.id, keyable_type:"Library::Course"}
        course_keys.push(c)
      }
    });
    folders.forEach(folder => {
      if(folder.access == true){
        let f = {global:false, access:true, keyable_id:folder.id, keyable_type:"ResourceCategory"}
        folder_keys.push(f)
      }
    });
    let data = {
      tool_keys: tool_keys,
      course_keys: course_keys,
      folder_keys: folder_keys
    }
    jfetch
    .patch(`/organizations/${props.orgID}/update_keys`, data)
    .then((resp) => {
      toast.success('Updated!')
      setLoading(false)      
    })
    .catch((error) => {
      toast.error("error saving updates")
      setLoading(false)
    })
  }

  function run_search(){
    if(search == ''){
      setTs(tools)
      setCs(courses)
      setFs(folders)
    }
    else{
      const s = search.toLowerCase()
      setTs( tools.filter( tool => tool.name.toLowerCase().includes(s) ) )
      setCs( courses.filter( course => course.name.toLowerCase().includes(s) ) )
      setFs( folders.filter( folder => folder.name.toLowerCase().includes(s) ) )
    }
  }


  return (
    
      <div className="row">
        <div className="col-lg-10">
          <h3>Organization Permissions</h3>
          <div className="form-inline">
            <div className="form-group">
              <div className="input-group">
                <div className="input-group-addon">
                  <i className="fa fa-search"/>
                </div>
                <input type="text" value={search} onChange={(event) => setSearch(event.target.value)} className="form-control" placeholder="search.."/>
              </div>
            </div>
          </div>          
          <Card>
          <table className="table table-hover">
              <thead>
              <tr>
                  <th scope="col" colSpan={3} className="text-center" style={{fontWeight:'bold'}}>Tools</th>
                </tr>                
                <tr>
                  <th scope="col">Name</th>
                  <th scope="col">Whitelist Access</th>
                  <th scope="col">Type</th>
                </tr>
              </thead>
              <tbody>
                {ts.map((tool) => {
                  return (
                    <tr key={tool.id}>
                      <td>{tool.name}</td>
                      <td>
                      <div className="checkbox">
                        <label style={{minHeight:'inherit', padding:0, display:'inline-block'}} >
                          <input 
                            onChange={(event) => {
                              let ts = [...tools]
                              ts.forEach((t) => {
                                if(t.id == tool.id){
                                  t.access = !t.access
                                }
                              })
                              setTools(ts)
                            }}
                            checked={tool.access}
                            type="checkbox" 
                            style={{position: 'relative', height:'inherit', padding:'inherit', margin:'inherit', display:'inline-block', marginRight:'8px'}}
                          />
                          Can View
                        </label>
                      </div>
                      </td>
                      <td>Tool</td>                      
                    </tr>
                  )
                })}  
                <tr>
                  <th scope="col" colSpan={3} className="text-center" style={{fontWeight:'bold'}}>Courses</th>
                </tr>                
                <tr>
                  <th scope="col">Name</th>
                  <th scope="col">Whitelist Access</th>
                  <th scope="col">Type</th>
                </tr>     
                {cs.map((course) => {
                  return (
                    <tr key={course.id}>
                      <td>{course.name}</td>
                      <td>
                      <div className="checkbox">
                        <label style={{minHeight:'inherit', padding:0, display:'inline-block'}} >
                          <input 
                            onChange={(event) => {
                              let cs = [...courses]
                              cs.forEach((c) => {
                                if(c.id == course.id){
                                  c.access = !c.access
                                }
                              })
                              setCourses(cs)
                            }}
                            checked={course.access}                          
                            type="checkbox" 
                            style={{position: 'relative', height:'inherit', padding:'inherit', margin:'inherit', display:'inline-block', marginRight:'8px'}}
                          />
                          Can View
                        </label>
                      </div>
                      </td>
                      <td>Course</td>                      
                    </tr>
                  )
                })}
                <tr>
                  <th scope="col" colSpan={3} className="text-center" style={{fontWeight:'bold'}}>Resources</th>
                </tr>                
                <tr>
                  <th scope="col">Name</th>
                  <th scope="col">Whitelist Access</th>
                  <th scope="col">Type</th>
                </tr>     
                {fs.map((folder) => {
                  return (
                    <tr key={folder.id}>
                      <td>{folder.name}</td>
                      <td>
                      <div className="checkbox">
                        <label style={{minHeight:'inherit', padding:0, display:'inline-block'}} >
                          <input 
                            onChange={(event) => {
                              let fs = [...folders]
                              fs.forEach((f) => {
                                if(f.id == folder.id){
                                  f.access = !f.access
                                }
                              })
                              setFolders(fs)
                            }}
                            checked={folder.access}                                
                            type="checkbox" 
                            style={{position: 'relative', height:'inherit', padding:'inherit', margin:'inherit', display:'inline-block', marginRight:'8px'}}
                          />
                          Can View
                        </label>
                      </div>
                      </td>
                      <td>Resource</td>                      
                    </tr>
                  )
                })}                                            
              </tbody>
            </table>
          </Card>
        </div>
        <div className="col-lg-2" style={{paddingTop:'10px'}}>
          <Button color="primary" loading={loading} onClick={update_keys}>
            Save
          </Button>
        </div>
      </div>
    
  )
}

export default OrgPermissions


// WEBPACK FOOTER //
// ./app/javascript/components/org/OrgPermissions.tsx